import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { Bucket, Granularity } from '../api/types.js';
import { formatGallons } from '../util/format.js';

interface ChartProps {
  buckets: Bucket[];
  granularity: Granularity;
  timezone: string;
}

function formatLabel(iso: string, granularity: Granularity, timezone: string): string {
  const date = new Date(iso);
  const opts: Intl.DateTimeFormatOptions =
    granularity === 'hour'
      ? { hour: 'numeric', day: 'numeric', month: 'short', timeZone: timezone }
      : granularity === 'month'
        ? { month: 'short', year: 'numeric', timeZone: timezone }
        : { month: 'short', day: 'numeric', timeZone: timezone };
  return new Intl.DateTimeFormat('en-US', opts).format(date);
}

export function Chart({ buckets, granularity, timezone }: ChartProps) {
  const data = buckets.map((b) => ({
    label: formatLabel(b.startIso, granularity, timezone),
    intervalGallons: b.intervalGallons,
  }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data} margin={{ top: 16, right: 16, left: 0, bottom: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis dataKey="label" tick={{ fontSize: 12 }} interval="preserveStartEnd" />
        <YAxis tick={{ fontSize: 12 }} label={{ value: 'gallons', angle: -90, position: 'insideLeft', style: { fontSize: 12 } }} />
        <Tooltip
          formatter={(value) => {
            const num = typeof value === 'number' ? value : Number(value ?? 0);
            return [formatGallons(num), 'Usage'];
          }}
          labelStyle={{ color: '#1f2330' }}
        />
        <Bar dataKey="intervalGallons" fill="#2563eb" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
